import type { Client, RequestContext } from "../client";
import { BasicRepository } from "../repositories/basicRepository";
import type { AuthenticationResource } from "./authenticationResource";
import type { LoginInitiatedResource } from "./loginInitiatedResource";

export class AuthenticationRepository extends BasicRepository<AuthenticationResource, AuthenticationResource> {
    constructor(client: Client, requestContext: RequestContext) {
        super("Authentication", client, requestContext);
    }
    get(): Promise<AuthenticationResource> {
        return this.client.get<AuthenticationResource>(this.requestContext, this.client.getLink("Authentication"));
    }

    wasLoginInitiated(encodedQueryString: string): Promise<LoginInitiatedResource> {
        return this.client.post<LoginInitiatedResource>(this.requestContext, this.client.getLink("LoginInitiated"), { EncodedQueryString: encodedQueryString });
    }
}
